export const getFormattedDate = (date) => {
  let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
  let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
  let timeHH = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
  let timeMM = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
  let timeSS = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
  let formattedDate = `${date.getFullYear()}${month}${day}${timeHH}${timeMM}${timeSS}`;
  return formattedDate;
}

export const getDisplayFullDateShort = (date) => {
  let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
  let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
  let timeHH = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
  let timeMM = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
  let timeSS = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
  let formattedDate = `${date.getFullYear()}-${month}-${day} ${timeHH}:${timeMM}:${timeSS}`;
  return formattedDate;
}

export const getDisplayTimeOnly = (date) => {
  let timeHH = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
  let timeMM = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
  let timeSS = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
  let formattedDate = `${timeHH}:${timeMM}:${timeSS}`;
  return formattedDate;
}

export function pad2(n) {
  // always returns a string
  return (n < 10 ? "0" : "") + n;
}

export const handleDateFormat = (currDate) => {
  let getYear = new Date(currDate).getFullYear();
  let getMonths = new Date(currDate).getMonth() + 1;
  let getDate = new Date(currDate).getDate();
  let getHours = new Date(currDate).getHours();
  let getMinutes = new Date(currDate).getMinutes();
  let getSeconds = new Date(currDate).getSeconds();
  return (
    pad2(getYear) +
    "-" +
    pad2(getMonths) +
    "-" +
    pad2(getDate) +
    " " +
    pad2(getHours) +
    ":" +
    pad2(getMinutes) +
    ":" +
    pad2(getSeconds)
  );
};

export const generateTime = (newTime) => {
  let currHours = new Date(newTime).getHours();
  let Hours = currHours > 9 ? currHours : "0" + currHours;
  let currMinutes = new Date(newTime).getMinutes();
  let Minutes = currMinutes > 9 ? currMinutes : "0" + currMinutes;
  let currSeconds = new Date(newTime).getSeconds();
  let Seconds = currSeconds > 9 ? currSeconds : "0" + currSeconds;
  return `${Hours}:${Minutes}:${Seconds}`;
};

export const generateDate = (currDate) => {
  let getYear = new Date(currDate).getFullYear();
  let getMonths = new Date(currDate).getMonth() + 1;
  let getDate = new Date(currDate).getDate();
  let tempDate = pad2(getYear) + "/" + pad2(getMonths) + "/" + pad2(getDate);
  return tempDate;
};

export const msToTime = (duration) => {
  if ((!duration) || (duration < 0)) {
    return '0h 0m 0s';
  }
  // var milliseconds = parseInt((duration % 1000) / 100),
  let seconds = Math.floor((duration / 1000) % 60);
  let minutes = Math.floor((duration / (1000 * 60)) % 60);
  let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  // return `${hours}: ${minutes} Minutes`;

  // , ${seconds} Seconds`
  return hours + "h " + minutes + "m " + seconds + "s";
}

export const msToTime2 = (duration) => {
  if ((!duration) || (duration < 0)) {
    return '00:00:00';
  }
  // var milliseconds = parseInt((duration % 1000) / 100),
  let seconds = Math.floor((duration / 1000) % 60);
  let minutes = Math.floor((duration / (1000 * 60)) % 60);
  let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  // return `${hours}: ${minutes} Minutes`;

  // , ${seconds} Seconds`
  return hours + ":" + minutes + ":" + seconds;
}

export const msToTimeForStatCardDuration = (duration) => {
  if ((!duration) || (duration < 0)) {
    return '00:00:00';
  }
  // var milliseconds = parseInt((duration % 1000) / 100),
  let seconds = Math.floor((duration / 1000) % 60);
  let minutes = Math.floor((duration / (1000 * 60)) % 60);
  let hours = Math.floor((duration / (1000 * 60 * 60)));

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  // return `${hours}: ${minutes} Minutes`;

  // , ${seconds} Seconds`
  return hours + ":" + minutes + ":" + seconds;
}

export const getTimeDifference = (startTime, endTime) => {
  if (!startTime || !endTime || endTime - startTime < 0) {
    return '0h 0m 0s';
  }
  const timeStr = new Date(endTime - startTime).toUTCString().slice(17, 25);
  const splitStr = timeStr.split(':');
  return splitStr[0] + 'h ' + splitStr[1] + 'm ' + splitStr[2] + 's';
}
